import { type GkAirProxyServiceWebResponseRecommendationsValue } from '@redteclab/api/clients/crosssellers-proxy-service'

export const recommendationAccessorGetWidgetTitle = ({
  widgetData,
}: {
  widgetData: GkAirProxyServiceWebResponseRecommendationsValue | undefined
}): string => {
  return widgetData?.title ?? ''
}
